import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import moment from 'moment'
import searches from '../../../../utils/routing/searches'

class SearchMadesResult extends Component {
  static propTypes = {
    searchMade: PropTypes.any.isRequired,
  }

  render() {
    const { searchMade, searchMade: { createdAt, searchParams: { keywords, search_query, university }} } = this.props

    if (!keywords && !search_query && !university) return null

    return (
      <div style={{marginBottom: 8}}>
        <Link to={searches.buildUrlForSearchType(searchMade)}>
          <div className="row m-0" style={{cursor: 'pointer'}}>
            <div style={{
              width: 40,
              textAlign: 'center',
            }}>
              <i className="fal fa-history" style={{fontSize: 20, paddingTop: 4}}/>
              <div style={{fontSize: 8, textAlign: 'center', marginTop: -3 }}>
                {createdAt && `${moment(createdAt).format("MMM D")}`}
              </div>
            </div>
            <div className="link-search-box">
              { keywords || search_query || university }
            </div>
            <div className="link-search-button">
              <i className="fal fa-search"/>
            </div>
          </div>
        </Link>
      </div>

    )
  }
}

export default SearchMadesResult



// WEBPACK FOOTER //
// ./src/components/ui/SearchHistory/SearchMades/SearchMadesResult.js